/**
 * Utilitário para detectar ambiente e configurações
 */

/**
 * Verifica se está rodando em desenvolvimento local
 */
export const isLocalDevelopment = (): boolean => {
  // Primeiro verificar se está embedado no Shopify (produção)
  // Se estiver embedado, NÃO é desenvolvimento local
  if (isEmbeddedInShopify()) {
    return false;
  }

  // Verificar hostname
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0') {
      return true;
    }
  }

  // Verificar variável de ambiente (mas só se não estiver embedado)
  // Em produção no Cloudflare, import.meta.env.DEV pode ser false mesmo em build de produção
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const shop = urlParams.get('shop');
    const host = urlParams.get('host');
    
    // Se tem shop ou host, é produção, não dev
    if (shop || host) {
      return false;
    }
    
    return true;
  }

  // Verificar se não tem parâmetros do Shopify (shop/host)
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const shop = urlParams.get('shop');
    const host = urlParams.get('host');
    
    // Se não tem shop nem host E não está em um domínio de produção conhecido
    if (!shop && !host) {
      const hostname = window.location.hostname;
      // Se não é localhost e não é um domínio conhecido de produção, assumir dev
      if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0') {
        return true;
      }
      // Se está em um domínio de produção (ex: storetoolsapp.com, pages.dev, cloudflare, etc), não é dev
      if (hostname.includes('storetoolsapp.com') || hostname.includes('.pages.dev') || hostname.includes('cloudflare') || hostname.includes('supabase')) {
        return false;
      }
    }
  }

  return false;
};

/**
 * Verifica se está embedado no Shopify (produção)
 */
export const isEmbeddedInShopify = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const urlParams = new URLSearchParams(window.location.search);
  const shop = urlParams.get('shop');
  const host = urlParams.get('host');
  
  return !!(shop && host);
};

/**
 * Obtém a URL base da aplicação
 */
export const getAppUrl = (): string => {
  if (isLocalDevelopment()) {
    return import.meta.env.VITE_APP_URL || 'http://localhost:3000';
  }
  
  // Em produção, usar variável de ambiente ou detectar da URL atual
  return import.meta.env.VITE_APP_URL || (typeof window !== 'undefined' ? window.location.origin : '');
};

